import React from "react";
import { Table as SharedTable } from "../../../../../../../shared/Table/Table";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../../../shared/Empty/Empty";
import { SortAdornment } from "../../../../../../../shared/SortAdornment/SortAdornment";
import { ContentLoader } from "../../../../../../../boxes/ContentLoader/ContentLoader";
import { VERTICALS_USAGE_REPORT_ORDER_BY } from "../../hooks/query/useVerticalsUsageReportQuery";

export function Table({ report = [], isLoading, order, handleRowClick }) {
  const { tBi } = useAppTranslation.BusinessInsights();
  const { tCommon } = useAppTranslation.Common();

  const isEmpty = report?.length === 0 && !isLoading;
  const isVisible = !isLoading && !isEmpty;

  const data = report?.map((r, i) => ({
    id: r.id,
    key: `${i}-${Object.values(r).join("-")}`,
    appointmentCount: r.appointment_count,
    name: r.name || tCommon("symbol.longDash"),
  }));

  const renderSortWrap = (children, field) => (
    <SortAdornment
      value={order.value.by === field ? order.value.direction : undefined}
      onToggle={() => order.update(field)}
    >
      {children}
    </SortAdornment>
  );

  return (
    <div>
      {isLoading && <Skeleton count={15} height={40.5} borderRadius="0px" />}
      {isEmpty && <Empty position="center" />}
      {isVisible && (
        <ContentLoader isLoading={isLoading}>
          <SharedTable
            bgColor="white"
            data={data}
            onRowClick={(row) => handleRowClick(row)}
            cols={[
              {
                data: renderSortWrap(
                  tBi("verticalsUsageReport.table.name"),
                  VERTICALS_USAGE_REPORT_ORDER_BY.name,
                ),
                accessor: "name",
              },
              {
                data: renderSortWrap(
                  tBi("verticalsUsageReport.table.appointmentCount"),
                  VERTICALS_USAGE_REPORT_ORDER_BY.appointmentCount,
                ),
                accessor: "appointmentCount",
              },
            ]}
          />
        </ContentLoader>
      )}
    </div>
  );
}
